<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
              style="float: left"
            ></DatePicker>

            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            pagination
            clickable-rows
            hover
            :fields="fields"
            :items="tableData"
          >
            <template #image="{ item }">
              <td>
                <img :Src="item.image" class="icon" />
              </td>
            </template>
            <template #Action="{ item }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item)"
                >
                  Edit </CButton
                ><br /><br />
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import firebase from "firebase";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
const db = firebase.firestore();
export default {
  components: { CTableWrapper, DatePicker },
  data() {
    return {
      value1: [],
      tableData: [],
      fields: [
        {
          label: "Logo",
          key: "image",
          sortable: true,
        },
        {
          label: "Game Name",
          key: "name",
          sortable: true,
        },
        {
          label: "startTime",
          key: "startTime",
          sortable: true,
        },
        {
          label: "endTime",
          key: "endTime",
          sortable: true,
        },
        {
          key: "Action",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("esportsGames")
        .where("gameUploadDate", ">=", v1)
        .where("gameUploadDate", "<=", v2)
        .orderBy("gameUploadDate", "desc")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));

            console.log("tableData", this.tableData);
          });

          this.loading = false;
        });
    },
  },
  methods: {
    wizard() {
      this.$router.push({ name: "htmlGameForm" });
    },
    editToken(item) {
      this.$router.push({
        name: "editHtmlGameForm",
        params: { id: item.id },
      });
    },
    getGames() {
      this.tableData = [];

      db.collection("HTMLGames")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));
          });
        })
        .catch((e) => console.log("errror", e));
    },
    assignsmallData(doc) {
      let smallDocument = {
        image: doc.data().icon,
        name: doc.id,
        startTime: moment(doc.data().startTime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        endTime: moment(doc.data().endTime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        // GameName: doc.data().name,
        // Limit: doc.data().participantLimit,
        // Price: doc.data().price,
        // RoomPassword: doc.data().roomPassword,
        // RoomID: doc.data().roomId,
        // EntryFees: doc.data().entrancePrice,
        // PoolStartDate: moment(doc.data().startTime.seconds * 1000).format(
        //   "DD-MMM-YYYY , hh:mm:ss:a"
        // ),
        // PooldEndDate: moment(doc.data().endTime.seconds * 1000).format(
        //   "DD-MMM-YYYY , hh:mm:ss:a"
        // ),
        // MatchStarttime: moment(doc.data().matchStartTime.seconds * 1000).format(
        //   "DD-MMM-YYYY , hh:mm:ss:a"
        // ),
        // gameUploadDate: moment(doc.data().gameUploadDate.seconds * 1000).format(
        //   "DD-MMM-YYYY , hh:mm:ss:a"
        // ),
      };
      return smallDocument;
    },
  },
  created() {
    this.getGames();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>
